import { Injectable, EventEmitter } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { map } from 'rxjs/operators';
import { Observable } from "rxjs";
import { ApiService } from "./api.service";
import { IAllLss, ILssLoaded, IEditLssSchedule } from 'app/models/lss';
import { Student } from "app/models/student";
import { Coach } from "app/models/coach";

type LssAssignedRecords = { members: Student[], coaches: Coach[] };

@Injectable({
  providedIn: "root"
})
export class LssService {
  currentPartnerInPartnerDashboard$ = new EventEmitter();

  constructor(private api: ApiService) {}

  getAllLss(params = {}): Observable<ILssLoaded[]> {
    const queryString = new HttpParams({ fromObject: params }).toString();
    return this.api.getData<IAllLss>(`/lsses?${queryString}`).pipe(map(res => res['data']['data']));
  }

  editLssSchedule(lssId: string, date: string, data: IEditLssSchedule) {
    return this.api.patch(`/lsses/schedule/${lssId}?scheduleDate=${date}`, data)
      .pipe(map((res) => res['data']?.data || res['data']));
  }

  getCssMembers(lssId: string): Observable<LssAssignedRecords> {
    return this.api.getData(`/lsses/${lssId}/assigned-members`).pipe(map(res => res['data']));
  }

}
